module.exports = __webpack_public_path__ + "img/meetyi_logo.830ee9d0.png";